export default "__VITE_ASSET__129fc8e7__"